// removed by extract-text-webpack-plugin
module.exports = {"block":"block_2qsVp","title":"title_VGLTm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/classAD/style.css
 ** module id = 933
 ** module chunks = 0
 **/